import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  roles: [],
  impersonatedUser: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.roles = action.payload.roles;
    },
    logout: (state) => {
      state.user = null;
      state.roles = [];
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.roles = action.payload.roles;
    },
    clearUser: (state) => {
      state.user = null;
      state.roles = [];
    },
    setImpersonatedPatrol: (state, action) => {
      state.impersonatedUser = action.payload
    }
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
